module.exports = __webpack_public_path__ + "static/media/country_bw.eb1e48c3.webp";